import styled from 'styled-components';

import { CloselinkMap, Position } from '../../../../common/Map/CloselinkMap';
import { PositionMarker } from '../../../../common/PositionMarker/PositionMarker';
import { Box } from '../../../../common/ui/Box';
import { PositionData } from '../types/PositionData';
import { getMarkerColor } from '../util/getMarkerColor';

const MapWrapper = styled(Box)`
    width: 100%;
    height: 200px;
    padding: 2px;
`;

interface OfferPositionsMapProps {
    center?: Position;
    zoom?: number;
    positionData: PositionData[];
    onCameraChanged: (center: Position, zoom: number) => void;
}

export const OfferPositionsMap = ({ positionData, center, zoom, onCameraChanged }: OfferPositionsMapProps) => {
    const places = positionData.map((data) => data.position);

    return (
        <MapWrapper>
            <CloselinkMap
                places={places}
                center={center}
                zoom={zoom}
                fitToBounds={!center}
                onCameraChanged={onCameraChanged}
            >
                {positionData.map((data) => {
                    const markerColor = getMarkerColor(data.type);

                    return (
                        <PositionMarker
                            key={data.id}
                            lat={data.position.lat}
                            lng={data.position.lng}
                            color={markerColor}
                        />
                    );
                })}
            </CloselinkMap>
        </MapWrapper>
    );
};
